import TrackNames from "../../services/applicationInsight/trackers";
import ROUTES from "./routes";
import { IconType } from "@france/superelements/lib";

export type FooterConfigType = {
  icon: IconType;
  path?: string;
  disabled?: boolean;
  label: string;
  mobileOnly?: boolean;
  trackingName?: TrackNames;
  trackingParams?: any;
};

export const footerConfig: FooterConfigType[] = [
  { icon: "home", path: ROUTES.HOME, label: "home", mobileOnly: true },
  {
    icon: "map-pin",
    path: ROUTES.POS,
    label: "pos",
    trackingName: TrackNames.PointOfSales,
  },
  {
    icon: "plus-square",
    path: ROUTES.SELECT_POS,
    label: "create_alt",
    mobileOnly: true,
    trackingName: TrackNames.ProposalStart,
    trackingParams: { type: "Complete" },
  },
  {
    icon: "document",
    path: ROUTES.MATERIALS,
    label: "catalog",
    trackingName: TrackNames.Materials,
  },
  {
    icon: "folder",
    path: ROUTES.PROPOSALS,
    label: "archive",
    trackingName: TrackNames.Archives,
  },
];
